import React from 'react'
import { Link } from 'gatsby'

const ContactButton = ({ onClick }) => (
  <div className="common-btn">
    <Link to={`/contact/`} onClick={onClick}>
      お問い合わせ
    </Link>
  </div>
)

export default ContactButton
